
import {connect} from 'react-redux';
import axios from 'axios';
import { Platform} from "react-native";

import ListNewsScreen from '../ListNewsScreen';
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";

const mapStateToProps = (state) => ({
    //item_count: state.reducerSplashGetAllData.results.item_count,
    results: state.reducerListNewsScreen.results,
    NoInternetDialog: state.reducerListNewsScreen.NoInternetDialog,
    showLoading: state.reducerListNewsScreen.showLoading,
    lazyload_end: state.reducerListNewsScreen.lazyload_end,
    showRefresh: state.reducerListNewsScreen.showRefresh,
    failed: state.reducerListNewsScreen.failed,
    page: state.reducerListNewsScreen.page,
    empty: state.reducerListNewsScreen.empty,
    DataSplashScreen: state.reducerSplashGetAllData,


    resultsSet: state.reducerListNewsScreen.resultsSet,
    isLoadingSet: state.reducerListNewsScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListNewsScreen.NoInternetDialogSet,
    id: state.reducerListNewsScreen.id,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    let pagee;
    let url_send = "";

    //let u = "http://samanebehnood.com" + `/api/application/api/list/sliders/with/paginate` + params + `&i=${page}`;


    switch (type) {
        case typeExport.TypeGetListNewsScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListNewsScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }
   axios(
        {
            // url: baseUrl + url + params,
            //url: url + "&after=0000-00-00",
            // url: url+`&${params.page}&${params.after}` ,
            url: url + params,
            // params:params,
            method: typeConnection,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: typeExport._TIMEOUT,
            /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
        }
    ).then(async response => {

        let data = response.data;
        switch (type) {

            case typeExport.TypeGetListNewsScreen:

                if (data.status) {
                    let arr = store.getState().reducerListNewsScreen.results

                    if (data == null) data = []
                    if (page == 1) {
                        arr = data.result
                    } else {
                        if (arr.length > 0)
                        //    arr.push(data.result);
                            arr = [...arr, ...data.result]
                        else
                            arr = data.result
                    }

                    if (data.result.length == item_count) {
                        pagee = page + 1;
                        dispatch(serviceActionSuccess(data.result, pagee));
                    }
                    // else {
                    //     page === 1 ? dispatch(serviceActionEmptyListNewsScreen(page)) : dispatch(serviceActionEndListNewsScreen(page));

                    // }
                    else {
                        (page === 1 & (data.result.length == 0)) ?
                            dispatch(serviceActionEmpty(page))
                            :
                            (pagee = page + 1, dispatch(serviceActionEnd(data.result, pagee)));
                    }


                    await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListNews+`${getState.route.params.item.id}`, arr)

                } else {
                    let data = await AsyngStorageClass.getASyng(global.IdCity +typeExport.ListNews+`${getState.route.params.item.id}`)
                    //this.props.callServiceSuccess(data, 0)
                    if (data != null)
                       dispatch(serviceActionSuccess(data, 0))
                    else
                       dispatch(serviceActionSuccess([], 0))
                }

                break;

            case typeExport.TypeSetListNewsScreen:
                if (data.status)
                    dispatch(serviceActionSuccessSet(data.result, id))
                else
                    alert(data.message)
                break;
            default:
        }
    }).catch((e) => {
        console.log(e)
        switch (type) {
            case typeExport.TypeGetListNewsScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListNewsScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //         if (isConnected) {

        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));

        //         }
        //     }

        //     );
        // }
        // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     });
        // }

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             switch (type) {
        //                 case typeExport.TypeGetListNewsScreen:
        //                     dispatch(serviceActionError(e, page))
        //
        //                     break;
        //                 case typeExport.TypeSetListNewsScreen:
        //                     dispatch(serviceActionErrorSet(e))
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )


                if (store.getState().reducerSplashGetAllData.Connection) {
                    getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
                } else {
                    switch (type) {
                        case typeExport.TypeGetListNewsScreen:
                            dispatch(serviceActionError('error_Connection', page))

                            break;
                        case typeExport.TypeSetListNewsScreen:
                            dispatch(serviceActionErrorSet('error_Connection'))
                            break;
                        default:
                    }
                }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListNewsScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListNewsScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListNewsScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListNewsScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListNewsScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListNewsScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1
})
export const serviceActionSuccess = (data, page) => ({

    type: typeExport.ListNewsScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.ListNewsScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListNewsScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListNewsScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListNewsScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export default connect(mapStateToProps, mapDispatchToProps)(ListNewsScreen);
